import React, { Component } from "react"
import queryStringify from "querystringify"
import { Redirect } from "react-router-dom"
import Admin from "./Admin"
import AdminRoom from "./AdminRoom"

export default class AdminFetcher extends Component {
  state = {
    loading: false,
    experiences: [],
    rooms: {},
  }

  fetchExperiences = async () => {
    if (!this.fetchExperiences.locked) {
      this.fetchExperiences.locked = true

      if (!this.state.experiences[0]) {
        this.setState({ loading: true })
      }

      let experiences = await fetch(
        process.env.REACT_APP_SERVER_URL +
          "/experiences?password=" +
          localStorage.getItem("password")
      )
        .then(async (response) => {
          if (response.status !== 200) {
            return []
          }

          return await response.json()
        })
        .catch(() => [])

      this.setState({ experiences, loading: false })

      this.fetchExperiences.locked = false
    }
  }

  componentDidMount() {
    this.fetchExperiences()
  }

  render() {
    const { experiences, loading, rooms } = this.state

    return (!queryStringify.parse(window.location.search).experience ||
      !experiences.find(
        ({ _id }) =>
          _id === queryStringify.parse(window.location.search).experience
      )) &&
      experiences[0] ? (
      <Redirect
        to={
          "/admin?experience=" +
          experiences.sort((a, b) =>
            a.name.toLowerCase() > b.name.toLowerCase()
              ? 1
              : a.name.toLowerCase() < b.name.toLowerCase()
              ? -1
              : 0
          )[0]._id
        }
      />
    ) : queryStringify.parse(window.location.search).room ? (
      <AdminRoom />
    ) : (
      <Admin
        experiences={experiences}
        setExperiences={(experiences) => this.setState({ experiences })}
        loading={loading}
        rooms={rooms}
        setRooms={(newRooms, experienceId) =>
          this.setState(({ rooms: oldRooms }) => ({
            rooms: { ...oldRooms, [experienceId]: newRooms },
          }))
        }
      />
    )
  }
}
